<template>
  <router-link :to="url">
    <div class="card card-lg card-grande">
      <div class="row header">
        <div class="col-xs-12">
          <h4>{{ title }}</h4>
        </div>
      </div>
      <div class="row body">
        <div class="col-xs-12">
          <span>{{ description }}</span>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      defaut: 'Titulo'
    },
    description: {
      type: String,
      defaut: 'Descrição'
    },
    url: {
      type: Object,
    }
  }
}
</script>

<style scoped>
  .card-grande {
    display: flex;
    flex-flow: column wrap;
  }

  .card-grande .header {
    flex: 1;
  }

  .card-grande .body {
    flex: 2;
    align-self: baseline;
  }
</style>


// WEBPACK FOOTER //
// src/components/common/CardLG.vue